import { graphql, useStaticQuery } from "gatsby";
import { useContext } from "react";
import { LocaleContext } from "../components/Layout/Layout";

const useTranslations = () => {
	const { rawData } = useStaticQuery(query);
	const { locale, forPage } = useContext(LocaleContext);

	const simplified = rawData.edges.map(item => ({
		name: item.node.name,
		translations: item.node.translations,
	}));

	const { translations } = simplified.filter(({ name }) => name === locale)[0];

	if (forPage === "customer_care") {
		return {
			...translations,
			...translations.customer_care,
		};
	}

	return translations;
};

export default useTranslations;

const query = graphql`
	query useTranslations {
		rawData: allFile(filter: { sourceInstanceName: { eq: "translations" } }) {
			edges {
				node {
					name
					translations: childLocalesJson {
						meta_data {
							index {
								title
								description
							}
							report {
								title
								description
							}
							privacy {
								title
								description
							}
							product {
								title
								description
							}
							terms {
								title
								description
							}
							funds {
								title
								description
							}
						}
						blog {
							page_title
							pagination {
								page
								prev
								next
								of
							}
							post_cta {
								title
								description
							}
							meta_data {
								index {
									title
									description
								}
							}
						}
						privacy_policy
						errorPage {
							not_found
							go_home
						}
						menu {
							login
							cc_report
							contact
							linkedin_profile
							product
						}
						header {
							heading
							paragraph
						}
						form {
							rodo
							privacy_policy
							success_message
							try_it
							placeholder_email
						}
						explanation_video
						infoCards {
							title
							cards {
								number
								title
								description
							}
						}
						getDemoButton
						how_it_works {
							title
							sections {
								title
								description
							}
						}
						call_to_action
						departments {
							title
							sections {
								title
								items
							}
						}
						reviews {
							title
							opinions {
								company
								description
								name
								role
							}
						}
						integrations {
							title
							description
						}
						faqs {
							title
							questions {
								question
								answer
							}
						}
						footer {
							title
							menus {
								menu_title
								items {
									text
								}
							}
						}
						privacy {
							title
							descriptions
						}
						funds {
							title
							descriptions
						}
						termsConditions {
							title
							descriptions
						}
						termsConditionsParagraphs {
							title
							descriptions {
								title
								subdescriptions
							}
						}
						cc_report_2020 {
							title
							descriptions
							form {
								name
								surname
								company
								get_report
								success_message
							}
							reportInformations {
								list_title
								list_items
							}
						}
						customer_care {
							header {
								heading
								paragraph
								mini
							}
							carousel {
								title
								description
							}
							infoCards {
								title
								cards {
									number
									title
									description
								}
							}
							reviews {
								title
								opinions {
									company
									description
									name
									role
								}
							}
							integrations {
								title
								description
							}
							departments {
								title
								sections {
									title
									description
								}
							}
							how_it_works {
								title
								sections {
									title
									description
								}
							}
							call_to_action {
								title
								href
								button
							}
						}
						product {
							header {
								heading
								paragraph
							}
							facts {
								value
								text
							}
							product_details {
								watch_video
								sections {
									title
									items {
										title
										description
									}
								}
							}
							overlaping {
								title
							}
							knowledge_integrations {
								title
								description
								items {
									name
									description
									short_name
								}
							}
							reviews {
								title
								description
							}
							cta {
								title
								description
							}
							abilities {
								title
								items {
									title
									description
								}
							}
							faqs {
								title
								questions {
									question
									answer
								}
							}
						}
					}
				}
			}
		}
	}
`;
